import styled from "@emotion/styled";

export const FullSizeContainer = styled.div`
  width: 100%;
  height: 100%;

  overflow: auto;
`;
